import React, { useContext } from 'react';
import { MenuItem, RaisedButton, SelectField } from 'material-ui';
import { AddUpdateContext } from './HiresPage';

function AddUpdateButtons({ style, labelStyle }) {
    const addUpdate = useContext(AddUpdateContext);

    return (
        <React.Fragment>
            <div className='col-xs-2'>
                <RaisedButton 
                    label='Add'
                    onClick={addUpdate.addRow}
                    primary
                    style={style}
                    labelStyle={labelStyle}
                />
            </div>
            <div className='col-xs-2'>
                <RaisedButton 
                    label='Update'
                    onClick={addUpdate.updateRows}
                    secondary
                    style={style}
                    labelStyle={labelStyle}
                />
            </div>
            <div className='col-xs-2' style={{ height: '48px' }}>
                <RaisedButton 
                    label='Export'
                    onClick={addUpdate.handleOpenExportDialog}
                    primary
                    style={style}
                    labelStyle={labelStyle}
                />
            </div>
        </React.Fragment>
    );
}

export default React.memo(AddUpdateButtons);



// WEBPACK FOOTER //
// ./app/components/Hires/AddUpdateButtons.jsx